import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import Benefit from "src/icons/Benefit";
import Calendar from "src/icons/Calendar";
import Free from "src/icons/Free";
import Scheme from "src/icons/Scheme";
import Valid from "src/icons/Valid";
import VideoCamera from "src/icons/Video-camera";
import Watch from "src/icons/Watch";
import { sButton } from "src/styles/sButton.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sWhyToUseCard } from "src/styles/sWhyToUseCard.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  specificContent?: boolean;
};

function WhyToUseInstructors({ style, className, specificContent }: Props) {
  const { locale: lang, push } = useRouter();

  return (
    <>
      <div
        className={composeClassNames([
          sWhyToUseCard,
          className,
          "whyToUse-cards",
        ])}
        style={style}
      >
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Free />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Profile for free`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Present yourself and your offer completely free of charge.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Benefit />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Discounts and benefits`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Take advantage of bonuses and discounted prices for instructors from the Vivido team at our partners.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Watch />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Courses, streams and audio`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Build passive income by offering different types of online content.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Calendar />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Events and festivals`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Offer your weekend stays, retreats or festivals and expand your client base.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Valid />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Sales and Publications`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`You just create the content and simply share it. We will take care of administration, publication and sales.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Scheme />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`More sales channels`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Sell through Vivido, on your website or through our partner network.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <VideoCamera />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type="h4"
              align="left"
              title={<Translate tKey={`Save money on equipment`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Rent a camera, microphone and lights from us or get advice on their selection and purchase.`}
              />
            </p>
          </div>
        </div>
      </div>
      <div className={"show-all"}>
        <Button
          variant="primary"
          onClick={() => push(constants.Paths.joinUs)}
          className={composeClassNames([sButton])}
        >
          <Translate tKey={`Join Vivido and create profile`} />
        </Button>
      </div>
    </>
  );
}

export default WhyToUseInstructors;
